module.exports = __webpack_public_path__ + "static/ogady-f7d682e03d6a05f4591023d2cb25d653.jpg";